import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export const CommunityOptInSla = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          alignItems: 'center',
        }}
      >
        <img
          src='/public/assets/icons/ic_community.svg'
          width={80}
          height={80}
        />
        <Typography sx={{ color: '#626a7a' }}>
          <FormattedMessage id='community.messages.empty.welcome' />
        </Typography>
      </Box>
    </Box>
  );
};
